import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminEcosystemServices = async (params = {}) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.ECOSYSTEM_SERVICES.GET_ALL, {
        params: { languageCode: 'vi', ...params },
    });
    return response.data;
};

export const getAdminEcosystemServiceById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.ECOSYSTEM_SERVICES.GET_BY_ID(id));
    return response.data;
};

export const createEcosystemService = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.ECOSYSTEM_SERVICES.CREATE, data);
    return response.data;
};

export const updateEcosystemService = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.ECOSYSTEM_SERVICES.UPDATE(id), data);
    return response.data;
};

export const deleteEcosystemService = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.ECOSYSTEM_SERVICES.DELETE(id));
    return response.data;
};
